import { TipoDomandaDTO } from '@framework/api-client';
import { InquiryTypeStateTag } from '@framework/common-web';
import { useCurrentLocale, useTranslation } from '@framework/i18n';
import { ISODate } from '@framework/ui';
import { Card } from 'antd';
import Title from 'antd/es/typography/Title';
import React from 'react';
import styled from 'styled-components';
import { getImageUrl } from '../../cover/component/getImageUrl';

const ListItemCard = styled(Card)`
  .ant-card-cover {
    background: ${props => props.theme.colorBorder};
    height: 200px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    align-items: center;
    border-radius: ${props => props.theme.borderRadius}px
      ${props => props.theme.borderRadius}px 0 0;

    margin-inline-start: 0;
    margin-inline-end: 0;
    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
    }
  }
`;
const ListItemButtonRow = styled.div`
  padding-top: 12px;
  display: flex;
  justify-content: flex-end;
`;
const ListItemStateRow = styled.div`
  padding-bottom: 12px;
`;
const InquiryListTitle = styled(Title)`
  &&& {
    font-size: ${props => props.theme.fontSizeHeading3};
  }
`;

export interface IInquiryListItemProps {
  inquiry?: TipoDomandaDTO;
  actions?: React.ReactNode;
}

export function InquiryListItem(props: IInquiryListItemProps) {
  const { inquiry, actions } = props;
  const { t } = useTranslation();
  const locale = useCurrentLocale();

  if (!inquiry) return null;
  const hasImage = !!inquiry?.copertina?.sfondo;
  const imageUrl = getImageUrl(inquiry?.copertina?.sfondo, locale.tag);

  const buttonText = inquiry.flNonInviabile
    ? t(
        'domande.lista.elemento.pulsante.dettaglio-domanda',
        'Vai alla procedura',
      )
    : t('domande.lista.elemento.pulsante.vai-alla-domanda', 'Vai alla Domanda');

  const buttonAriaLabel = buttonText + ' ' + inquiry.titolo;

  return (
    <ListItemCard
      cover={
        hasImage ? (
          <img
            alt={t(
              'domande.lista.elemento.alt-immagine.copertina-domanda',
              'copertina domanda',
            )}
            src={imageUrl}
          />
        ) : (
          <div />
        )
      }
    >
      <div key={inquiry.id}>
        <ListItemStateRow>
          <InquiryTypeStateTag inquiry={inquiry} />
          {inquiry.dataFine && (
            <>
              {t('domande.lista.elemento.etichetta.scadenza', 'Scadenza')}:{' '}
              <ISODate date={inquiry.dataFine} format="DD/MM/YYYY" in24Hours />
            </>
          )}
        </ListItemStateRow>
        <InquiryListTitle level={2}>{inquiry.titolo}</InquiryListTitle>
        <ListItemButtonRow>{actions}</ListItemButtonRow>
      </div>
    </ListItemCard>
  );
}
